<template>

  <div>
    <div class="flex mb-10">
      <el-dropdown>
        <el-button>
          Manage all queues
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="logInAll">
            Login all
          </el-dropdown-item>
          <el-dropdown-item @click.native="logoutAll">
            Logout all
          </el-dropdown-item>
          <el-dropdown-item>
            <span @click="pauseAllReasonActive = true">
              Pause all
            </span>
          </el-dropdown-item>
          <el-dropdown-item>
            <span @click="unpauseAll">
              Unpause all
            </span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <div class="vxe-table card-base card-shadow--medium" style="height: 360px;">
      <vxe-grid
        round
        border="inner"
        ref="xGrid"
        height="100%"
        auto-resize
        empty-text="No Data"
        resizable
        show-overflow="tooltip"
        highlight-hover-row
        :data="tableData"
        :sort-config="{defaultSort: {field: 'queue', order: 'asc'}}"
        :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
        :columns="tableColumns"
        :loading="tableLoading"
      />
    </div>

    <el-dialog
      width="430px"
      :modal="false"
      :visible.sync="pauseAllReasonActive"
    >
      <el-form class="form-modal" style="min-height: 440px;">
        <h2 class="form-section-header">
          Agent Pause Reason
        </h2>
        <el-select
          v-model="pauseReason"
          placeholder="Select Reason"
          :value="pauseReason">
          <template slot="prefix">Reason</template>
          <el-option
            value="Account Review"
            label="Account Review"
          />
          <el-option
            value="Break"
            label="Break"
          />
          <el-option
            value="Lunch"
            label="Lunch"
          />
          <el-option
            value="Meeting"
            label="Meeting"
          />
          <el-option
            value="Personal"
            label="Personal"
          />
          <el-option
            value="Other"
            label="Other"
          />
        </el-select>
        <el-input
          type="text"
          v-model="otherPauseReason"
          placeholder="Enter Other"
          v-if="pauseReason === 'Other'">
          <template class="label-prefix" slot="prefix">Other Reason</template>
        </el-input>
        <div class="inline-form-group justify-flex-end">
          <el-button
            @click="pauseAll">
            Submit
          </el-button>
          <el-button
            @click="pauseAllReasonActive = false">
            Cancel
          </el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>

</template>

<script>

import feathersClient from '@/feathers/feathers-client';
import pauseIcons from "@/ref/pause-icons";
import {globalEventBus} from "@/globalEventBus";

export default {
  name: 'QueueManagement',
  data() {
    return {
      tableLoading: false,
      tableData: [],
      pauseReason: '',
      otherPauseReason: '',
      pauseAllReasonActive: false,
      tableColumns: [
        {
          field: 'queue',
          title: 'Queue',
          sortable: true,
          width: 150,
          showOverflow: true,
          slots: {
            default: ({row}) => {
              return [
                <div class="pv-8">
                  {row.queue}
                </div>
              ]
            }
          }
        },
        {
          field: 'loggedIn',
          title: 'Log In',
          width: 75,
          slots: {
            default: ({row}) => {
              return [
                <el-switch
                  value={row.isLoggedIn}
                  active-color="#46CA63"
                  onChange={() => {this.handleLogin(row)}}
                />
              ]
            }
          }
        },
        {
          field: 'paused',
          title: 'Pause',
          width: 75,
          slots: {
            default: ({row}) => {
              return [
                <el-popover trigger="click" placement="bottom-end" ref={row._XID} v-show={row.isLoggedIn}>
                  <el-switch
                    slot="reference"
                    value={row.isPaused}
                    active-color="#FF6827"
                    onChange={() => {if(row.isPaused){
                      setTimeout( () => {
                        this.handlePause(row);
                      }, 100)
                    }}}
                  />
                  <div>
                    <el-form class="form-modal">
                      <el-select
                        v-model={this.pauseReason}
                        placeholder="Select Reason"
                        value={this.pauseReason}
                      >
                        <template slot="prefix">Reason</template>
                        <el-option
                          value="Account Review"
                          label="Account Review"
                        />
                        <el-option
                          value="Break"
                          label="Break"
                        />
                        <el-option
                          value="Lunch"
                          label="Lunch"
                        />
                        <el-option
                          value="Meeting"
                          label="Meeting"
                        />
                        <el-option
                          value="Personal"
                          label="Personal"
                        />
                        <el-option
                          value="Other"
                          label="Other"
                        />
                      </el-select>
                    </el-form>
                  </div>
                  {this.pauseReason === 'Other' &&
                    <div class="mb-10">
                      <el-form class="form-modal">
                        <el-input
                          type="text"
                          v-model={this.otherPauseReason}
                          placeholder="Enter other"
                        >
                          <template className="label-prefix" slot="prefix">Other Reason</template>
                        </el-input>
                      </el-form>
                    </div>
                  }
                  <el-button
                    onClick={() => this.handlePause(row)}
                  >
                    Submit
                  </el-button>
                </el-popover>

              ]
            }
          }
        },
        {
          field: 'pauseIcon',
          width: 48,
          slots: {
            default: ({row}) => {
              return [
                <div v-show={row.isPaused} class="mt-10">
                  <el-tooltip placement="top" content={row.pauseReason}>
                    <v-svg class="voxo-orange pause-icon" sprite={this.getPauseIcon(row.pauseReason)}/>
                  </el-tooltip>
                </div>
              ]
            }
          }
        },
        {
          field: ''
        }
      ]
    }
  },
  computed: {
    user(){
      return this.$store.state.auth.user;
    }
  },
  methods: {
    async getQueueInfo(){

      const { myExtension } = this.user;
      const { peerName, queueIds } = myExtension

      //get logged in queues
      const loggedInQueues = await feathersClient.service('queuemembers').find({
        query: {
          queueName: {$in: queueIds},
          memberdevice: peerName
        }
      });

      const activeQueueIds = loggedInQueues.map(item => +item.queueName);
      const loggedOutQueueIds = queueIds.filter(item => !activeQueueIds.includes(item));

      //get logged out queues
      const loggedOutQueues = loggedOutQueueIds.length
        ? await feathersClient.service('queuemembers-allowed').find({
          query: {
            queueName: {$in: loggedOutQueueIds},
            memberdevice: peerName
          }
        })
        : []

      return [...loggedInQueues, ...loggedOutQueues];

    },

    getPauseIcon(reason) {
      return pauseIcons(reason);
    },

    handleLogin(queue){
      //for specific queue based on value send to the login or logout function
      const val = queue.isLoggedIn ? 0 : 1;
      val ? this.login(queue) : this.logout(queue);
    },
    async handlePause(queue){

      this.$refs[queue._XID].showPopper = false;
      //for specific queue based on value send to pause or unpause function
      let pauseReason = this.pauseReason;
      const val = queue.isPaused ? 0 : 1;
      if(!pauseReason.length || pauseReason === 'Other'){
        this.pauseReason = this.otherPauseReason;
      }

      //use must provide a pause reason
      if(!pauseReason.length && val){
        this.$notify({
          title: 'Warning',
          message: 'You Must Include A Pause Reason!',
          type: 'warning'
        });
      } else{
        val ? await this.pause(queue) : await this.unpause(queue);
        this.pauseReason = '';
        this.otherPauseReason = '';
      }

    },
    login(queue){

      //log in to queue
      //send the request.
      const {myExtension} = this.user;
      const {id: extensionId} = myExtension;
      const {membername: memberName, memberdevice: peerName, queueName: queueId} = queue;

      feathersClient.service('nats-actions-handler').create({
        reqType: 'queueLogin',
        peerName,
        queueId,
        memberName,
        extensionId
      }).then( () => {
        //update the switcher
        queue.isLoggedIn = true;
        queue.loggedIn = 1;
      }).catch(() => {
        console.log('something went wrong')
      });
    },
    logout(queue){

      //if user is paused send the unpause request first
      //send the logout request
      const {myExtension} = this.user;
      const {id: extensionId} = myExtension;
      const {membername: memberName, memberdevice: peerName, queueName: queueId} = queue;

      if(queue.isPaused){
        this.handlePause(queue);
      }

      feathersClient.service('nats-actions-handler').create({
        reqType: 'queueLogout',
        peerName,
        queueId,
        memberName,
        extensionId
      }).then( () => {
        queue.isLoggedIn = false;
        queue.loggedIn = 0;
      }).catch(() => {
        console.log('something went wrong')
      });

    },
    async pause(queue){

      const {myExtension} = this.user;
      const {id: extensionId} = myExtension;
      const {membername: memberName, memberdevice: peerName, queueName: queueId, interface: memberInterface} = queue;
      this.$refs[queue._XID].showPopper = false;

      //send unpause for queue
      await feathersClient.service('nats-actions-handler').create({
        reqType: 'queuePause',
        paused: 1,
        pauseReason: this.pauseReason,
        peerName,
        extensionId,
        memberName,
        queueId,
        interface: memberInterface
      }).then( () => {
        queue.isPaused = true;
        queue.paused = 1;
        queue.pauseReason = this.pauseReason;
      }).catch( () => {
        console.log('something went wrong');
      });

    },
    async unpause(queue){

      const {myExtension} = this.user;
      const {id: extensionId} = myExtension;
      const {membername: memberName, memberdevice: peerName, queueName: queueId, interface: memberInterface} = queue;

      //send unpause for queue
      await feathersClient.service('nats-actions-handler').create({
        reqType: 'queueUnpause',
        paused: 0,
        pauseReason: this.pauseReason,
        peerName,
        extensionId,
        memberName,
        queueId,
        interface: memberInterface
      }).then( () => {
        queue.isPaused = false;
        queue.paused = 0;
      }).catch( () => {
        console.log('something went wrong');
      });

    },
    logInAll(){

      //send login request for each
      const queuesToLogin = this.tableData.filter(item => !item.isLoggedIn);
      queuesToLogin.forEach(item => { this.login(item) });

    },
    logoutAll(){

      const queuesToLogout = this.tableData.filter(item => item.isLoggedIn);
      queuesToLogout.forEach(item => { this.logout(item) });

    },
    async pauseAll(){

      //loop over each queue and send to the pause for queue function
      let pauseReason = this.pauseReason;
      if(!pauseReason.length || pauseReason === 'Other'){
        this.pauseReason = this.otherPauseReason;
      }

      //use must provide a pause reason
      if(!pauseReason.length){
        this.$notify({
          title: 'Warning',
          message: 'You Must Include A Pause Reason!',
          type: 'warning'
        });
      } else{
        const queuesToPause = this.tableData.filter(item => item.isLoggedIn);
        for(let i = 0; i < queuesToPause.length; i++){
          await this.pause(queuesToPause[i]);
        }
        this.pauseAllReasonActive = false;
        this.pauseReason = '';
        this.otherPauseReason = '';
      }
    },
    unpauseAll(){

      //loop over each queue and send to the unpause for queue function
      const queuesToUnpause = this.tableData.filter(item => item.isLoggedIn && item.isPaused);
      queuesToUnpause.forEach(item => {this.unpause(item)});
      this.pauseAllReasonActive = false;
      this.pauseReason = '';
      this.otherPauseReason = '';
    },
    handleCloseModal(){
      this.$emit('modalClosed');
    },
    async loadQueues(){
      this.tableLoading = true;
      this.tableData = await this.getQueueInfo();
      this.tableLoading = false;
    }
  },
  created() {

    //event listeners for login / pause events
    feathersClient.service('channel-memberships').on('queueMemberPause', (data) => {
      const { queueId, paused, pauseReason } = data;
      const queueIndex = this.tableData.findIndex(item => +item.queueName === queueId);

      if(queueIndex >= 0) {
        let queue = this.tableData[queueIndex];
        queue.isPaused = !!+paused;
        queue.pauseReason = pauseReason ? pauseReason : '';
        this.tableData.splice(queueIndex, 1, queue);
      }

    });

    feathersClient.service('channel-memberships').on('queueRefresh', (data) => {
      const { loggedin, queueId } = data;
      if(loggedin){
        const queueIndex = this.tableData.findIndex(item => +item.queueName === +queueId);
        if(queueIndex >= 0) {
          let queue = this.tableData[queueIndex];
          queue.isLoggedIn = !!+loggedin;
          this.tableData.splice(queueIndex, 1, queue);
        }
      }
    });

    //reload queues on app connect
    globalEventBus.$on('appReconnected', () => {
      this.tableData = [];
      this.loadQueues();
    })


  },
  mounted() {
    this.loadQueues();
  }
}

</script>
